import { useEffect, useState } from 'react';
import './ColorAndPenPicker.less';
import ColorPicker from '@rc-component/color-picker';
import '@rc-component/color-picker/assets/index.css';
import { Slider } from 'antd';
import toast from 'react-hot-toast';

export default function ColorAndPenPicker({ onSizeChange, onColorChange }) {
  const [size, setSize] = useState(1);
  const [eyeDropperColor, setEyeDropperColor] = useState('#fff');
  const [color, setColor] = useState('#fff'); // 默认颜色值

  useEffect(() => {}, []);
  const startPickColor = async () => {
    if ('EyeDropper' in window) {
      const eyeDropper = new EyeDropper();
      try {
        const result = await eyeDropper.open();
        setEyeDropperColor(result.sRGBHex);
        onColorChange(result.sRGBHex);
        setColor(result.sRGBHex);
        // document.getElementById('pickedColor').textContent = result.sRGBHex;
        // document.getElementById('pickedColor').style.backgroundColor = result.sRGBHex;
      } catch (err) {
        console.error('用户取消或不支持：', err);
      }
    } else {
      toast('你的浏览器不支持 EyeDropper API');
      // alert('你的浏览器不支持 EyeDropper API');
    }
  };
  return (
    <div
      className="color-and-pen-picker"
      onClick={(event) => {
        event.stopPropagation();
        event.preventDefault();
      }}>
      <div className="color-header">
        <div className="xi-pen" onClick={startPickColor}></div>
        <div className="color-result" style={{ backgroundColor: eyeDropperColor }}></div>
      </div>
      <ColorPicker
        value={color}
        onChange={(v) => {
          setColor(v);
          onColorChange(v);
          setEyeDropperColor(v);
        }}
        style={{ backgroundColor: '#222', background: 'none' }}></ColorPicker>
      <div className="slider-row">
        <div className="title">大小</div>
        <Slider
          min={0}
          max={0.1}
          style={{ flex: 1 }}
          step={0.002}
          onChange={(value) => {
            console.log('value', value);
            onSizeChange(value);
          }}></Slider>
      </div>
    </div>
  );
}
